export default __webpack_public_path__ + "9945c9202f953c033e5bd9d907b8d5e3.png";